@if (edit) {
  <div class="edit">
    <h3 translate>Machine</h3>
    @if (machinesSearchService?.firstSelectedResult$ | async; as machine) {
      <div class="machine-info">
        <div class="machine-info-row">
          <div class="row-label" translate>Machine Name</div>
          <div class="row-value">{{ machine.name }}</div>
        </div>
        <div class="machine-info-row">
          <div class="row-label" translate>Serial Number</div>
          <div class="row-value">{{ machine.serial }}</div>
        </div>
        <div class="machine-info-row">
          <div class="row-label" translate>Plant</div>
          <div class="row-value">{{ machine.plant }}</div>
        </div>
        <div class="machine-info-row">
          <div class="row-label" translate>Manufacturer</div>
          <div class="row-value">{{ machine.manufacturer }}</div>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="grid">
    <div class="grid-header">
      <h4>{{ 'VALUE Machines' | translate: { value: machinesSearchService?.state.total } }}</h4>
    </div>
    @if (machinesSearchService) {
      <rotec-default-grid-v2
        [height]="height"
        [columns]="machinesSearchService?.columns"
        [data]="machinesSearchService?.state$ | async"
        [darkMode]="true"
        [menuButton]="false"
        [selectConfig]="selectConfig"
        [filterButton]="false"
        [selectedResults]="machinesSearchService?.selectedIds$ | async"
        (stateChange)="machinesSearchService?.search($event)"
        (selectedResultsChange)="setSelectedMachinesIds($event)"
        (fulltextSearchChanged)="machinesSearchService?.search({ fulltext: $event })"
      >
        <ng-template rotecGridCellV2="name" let-dataItem="dataItem">
          <p class="grid-text-cell">{{ dataItem.name }}</p>
        </ng-template>
        <ng-template rotecGridCellV2="serial" let-dataItem="dataItem">
          <p class="grid-text-cell">{{ dataItem.serial }}</p>
        </ng-template>
        <ng-template rotecGridCellV2="_groups" let-dataItem="dataItem">
          <p class="grid-text-cell">{{ dataItem.groups }}</p>
        </ng-template>
        <ng-template rotecGridCellV2="manufacturer" let-dataItem="dataItem">
          <p class="grid-text-cell">{{ dataItem.manufacturer }}</p>
        </ng-template>
        <ng-template rotecGridCellV2="plant" let-dataItem="dataItem">
          <p class="grid-text-cell">{{ dataItem.plant }}</p>
        </ng-template>
      </rotec-default-grid-v2>
    }
  </div>
}
